import { NgModule } from '@angular/core';
import {
  BrowserModule,
  provideClientHydration,
} from '@angular/platform-browser';
import { CommonModule } from '@angular/common';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AvatarModule } from 'primeng/avatar';
import { InputTextModule } from 'primeng/inputtext';
import { MenubarModule } from 'primeng/menubar';
import { BadgeModule } from 'primeng/badge';
import { MenuModule } from 'primeng/menu';

import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';

import { HeaderComponent } from './features/trading-terminal/components/header/header.component';
import { FooterComponent } from './features/trading-terminal/components/footer/footer.component';
import { AuthInterceptorsService } from './shared/interceptors/auth-interceptors.service';
import { ToastModule } from 'primeng/toast';
import { RippleModule } from 'primeng/ripple';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { NumberFormatPipe } from './shared/pipes/number-format.pipe';
import { BottomNavComponent } from './features/trading-terminal/components/bottom-nav/bottom-nav.component';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { ChipsModule } from 'primeng/chips';
import { InputNumberModule } from 'primeng/inputnumber';
import { CardModule } from 'primeng/card';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { DialogModule } from 'primeng/dialog';
import { MessagesModule } from 'primeng/messages';
import { AccordionModule } from 'primeng/accordion';
import { HomeComponent } from './features/home/home.component';
import { PanelModule } from 'primeng/panel';
import { SidebarModule } from 'primeng/sidebar';
import { SupportComponent } from './features/support/support.component';
import { AboutUsComponent } from './features/about-us/about-us.component';
import { FeesComponent } from './features/fees/fees.component';
import { TableModule } from 'primeng/table';
import { DropdownModule } from 'primeng/dropdown';
@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    NumberFormatPipe,
    BottomNavComponent,
    HomeComponent,
    SupportComponent,
    AboutUsComponent,
    FeesComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    MenubarModule,
    MenuModule,
    AvatarModule,
    BadgeModule,
    InputTextModule,
    ToastModule,
    RippleModule,
    ButtonModule,
    OverlayPanelModule,
    InputGroupModule,
    InputGroupAddonModule,
    ChipsModule,
    CardModule,
    CommonModule,
    FormsModule,
    InputNumberModule,
    NgxSliderModule,
    DialogModule,
    MessagesModule,
    AccordionModule,
    PanelModule,
    SidebarModule,
    TableModule,
    DropdownModule,
    ReactiveFormsModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorsService,
      multi: true,
    },
    MessageService,
    provideClientHydration(),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
